export enum SSEEvent {
  PROGRESS = 'progress',
  CHAT_STATUS = 'chat_status',
}
